<div class="app-admin-navigation">

    <nav>
        <ul>
            @if (!isAdminAssistantDetail) {
                <!-- dashboard -->
                <li>
                    <a [routerLink]="'dashboard' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_dashboard' | translate" [animation]="true">
                        <i class="icon icon-nav-dashboard"></i>
                    </a>
                </li>
                <!-- reports superadmin -->
                @if (user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'reports' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_reports' | translate" [animation]="true">
                            <i class="icon icon-nav-reports"></i>
                        </a>
                    </li>
                }
                <!-- reports admin + has report types -->
                @if (!user().adminInfo?.superadmin && user().adminInfo?.reportTypes?.length) {
                    <li>
                        <a [routerLink]="'reports' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_reports' | translate" [animation]="true">
                            <i class="icon icon-nav-reports"></i>
                        </a>
                    </li>
                }
                <!-- students admin -->
                @if (!user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'assistants' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="studentsLabel()" [animation]="true">
                            <i class="icon icon-nav-users"></i>
                        </a>
                    </li>
                }
                <!-- supervisors admin -->
                @if (!user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'supervisors' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_supervisors' | translate" [animation]="true">
                            <i class="icon icon-nav-supervisors"></i>
                        </a>
                    </li>
                }
                <!-- users superadmin -->
                @if (user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'users' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_users' | translate" [animation]="true">
                            <i class="icon icon-nav-users"></i>
                        </a>
                    </li>
                }
                <!-- locations -->
                <li>
                    <a [routerLink]="'locations' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_locations' | translate" [animation]="true">
                        <i class="icon icon-nav-locations"></i>
                    </a>
                </li>
                <!-- trainings admin -->
                @if (!user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'trainings' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_trainings' | translate" [animation]="true">
                            <i class="icon icon-nav-trainings"></i>
                        </a>
                    </li>
                }
                <!-- trainings superadmin -->
                @if (user().adminInfo?.superadmin) {
                    <li>
                        <a [routerLink]="'trainings' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_trainings' | translate" [animation]="true">
                            <i class="icon icon-nav-trainings"></i>
                        </a>
                    </li>
                }
                <!-- messages -->
                <li>
                    <a [routerLink]="'messages' | prefixSubscription" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" [placement]="['right', 'auto']" [container]="'body'" [triggers]="'hover'" [ngbTooltip]="'adminnav_messages' | translate" [animation]="true">
                        <i class="icon icon-nav-messages"></i>
                    </a>
                </li>
            } @else {
                <li>
                    <a data-replace-href-back-to-admin [href]="'assistants' | prefixSubscription">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.27865 2.99361C7.11806 3.00012 6.96398 3.06739 6.84896 3.18241L2.68229 7.34908C2.43924 7.5943 2.43924 7.98927 2.68229 8.2345L6.84896 12.4012C7.00738 12.5639 7.23958 12.629 7.45877 12.5726C7.67795 12.5162 7.84939 12.3447 7.90582 12.1256C7.96224 11.9064 7.89714 11.6742 7.73438 11.5157L4.63325 8.41679H12.0833C14.3924 8.41679 16.25 10.2744 16.25 12.5835C16.25 14.8925 14.3924 16.7501 12.0833 16.7501H8.95833C8.73264 16.748 8.52431 16.8651 8.40929 17.0605C8.29644 17.2558 8.29644 17.4945 8.40929 17.6898C8.52431 17.8851 8.73264 18.0023 8.95833 18.0001H12.0833C15.0673 18.0001 17.5 15.5674 17.5 12.5835C17.5 9.59951 15.0673 7.16679 12.0833 7.16679H4.63325L7.73438 4.06783C7.91884 3.88771 7.97309 3.6121 7.87326 3.37555C7.77344 3.13901 7.53689 2.9871 7.27865 2.99361Z" fill="#91A2AF"/>
                        </svg>
                    </a>
                </li>
            }
        </ul>
    </nav>

    <div class="bottom">
        <button 
            class="avatar-wrap"
            #profilePopoverRef="ngbPopover"
            [ngbPopover]="profilePopover"
            [popoverClass]="'popover--profile'" 
            [placement]="'right-bottom'" 
            [container]="'body'"
            [autoClose]="'outside'"
            [animation]="false"
            >
            <app-avatar [size]="34" [fontSize]="14" [type]="user().type" [firstname]="user().firstname" [lastname]="user().lastname" [image]="user().avatar"/>
        </button>
    </div>

</div>

<!-- profile popover -->
<ng-template #profilePopover>
    <div class="profile-wrap">
        <app-avatar [size]="30" [fontSize]="14" [type]="user().type" [firstname]="user().firstname" [lastname]="user().lastname" [image]="user().avatar"/>
        <div class="user-info">
            <div class="title">{{user().fullname}}</div>
            <div class="descr"><ng-container [ngTemplateOutlet]="userDescr" [ngTemplateOutletContext]="{user: user()}"/></div>
        </div>
    </div>
    <!-- accounts -->
    <div class="accounts-wrap" [attr.inert]="switchingToAccountId || null">
        <div class="popover-title">{{'profilepopover_accounts_title' | translate}}</div>
        <div class="accounts-list">
            @for (subscription of user().subscriptions; track $index) {
                <a [href]="subscription.role + '/' + subscription.id | prependDevUrlForEnvDevelopment" (click)="switchAccount($event, subscription.id)" class="account-button account-button--{{subscription.role}}" [class.active]="(switchingToAccountId === subscription.id) || (!switchingToAccountId && subscription.id === user().subscriptionId)" [class.saving]="switchingToAccountId && switchingToAccountId !== subscription.id">
                    <i class="radio"></i>
                    <div class="info-wrap">
                        <!-- role / status -->
                        <div class="title">
                            @switch (subscription.role) {
                                @case ('assistant') { {{subscription.trainingDescr}} }
                                @case ('supervisor') { {{user().jobTitle || ('misc_professional_account' | translate)}} }
                                @case ('pro') { {{('misc_pro_account' | translate)}} }
                                @case ('staff') { {{('misc_staff_account' | translate)}} }
                                @case ('admin') { {{ !subscription.organisationDescr ? 'Super admin' : 'Admin' }} }
                            }
                            @switch (subscription.status) {
                                @case ('expired') { <div class="type-stamp type-stamp--orange">{{'status_expired' | translate}}</div> }
                                @case ('archived') { <div class="type-stamp type-stamp--disabled">{{'status_archived' | translate}}</div> }
                            }
                        </div>
                        <!-- descr (organisation / - / organisation) -->
                        @if ((subscription.role === 'assistant' || subscription.role === 'staff' || subscription.role === 'admin') && subscription.organisationDescr) { <div class="descr ellipsis">{{subscription.organisationDescr}}</div> }
                    </div>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
                        <g id="surface5886">
                            <path id="Vector" d="M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z M8,1.2
                                c3.8,0,6.8,3,6.8,6.8c0,3.8-3,6.8-6.8,6.8c-3.8,0-6.8-3-6.8-6.8C1.2,4.2,4.2,1.2,8,1.2z M8,3.2C7.2,3.2,6.6,3.5,6.2,4
                                C5.8,4.4,5.6,5,5.6,5.6s0.2,1.2,0.6,1.6C6.6,7.7,7.2,8,8,8s1.4-0.3,1.8-0.8c0.4-0.5,0.6-1.1,0.6-1.6S10.2,4.4,9.8,4
                                C9.4,3.5,8.7,3.2,8,3.2z M8,4.4c0.4,0,0.7,0.1,0.9,0.4C9.1,5,9.2,5.3,9.2,5.6c0,0.3-0.1,0.6-0.3,0.8C8.7,6.7,8.4,6.8,8,6.8
                                c-0.4,0-0.7-0.1-0.9-0.4C6.9,6.2,6.8,5.9,6.8,5.6c0-0.3,0.1-0.6,0.3-0.8C7.3,4.5,7.5,4.4,8,4.4z M5.3,8.8C4.6,8.8,4,9.4,4,10.1v0.4
                                c0,0.8,0.5,1.5,1.2,1.9c0.7,0.5,1.7,0.7,2.8,0.7c1.1,0,2.1-0.3,2.8-0.7c0.7-0.5,1.2-1.1,1.2-1.9v-0.4c0-0.7-0.6-1.3-1.3-1.3H5.3z
                                M5.3,10h5.4c0.1,0,0.1,0,0.1,0.1v0.4c0,0.3-0.2,0.6-0.7,0.9C9.7,11.8,8.9,12,8,12s-1.7-0.2-2.1-0.5c-0.5-0.3-0.7-0.6-0.7-0.9v-0.4
                                C5.2,10,5.2,10,5.3,10z"/>
                        </g>
                    </svg>

                </a>
            }
        </div>
    </div>
    <!-- logout -->
    <div class="logout-wrap">
        <button (click)="authService.logout()" class="popover-link"><div class="legacy-link-inner">{{'profilepopover_link_logout' | translate}} <i class="icon icon-logout"></i></div></button>
    </div>
</ng-template>

<!-- @link user descr -->
<ng-template #userDescr let-user="user">
    @switch (user.type) {
        @case ('assistant') { {{user.trainingDescr}} }
        @case ('supervisor') { {{user().jobTitle || ('misc_professional_account' | translate)}} }
        @case ('staff') { {{user.trainingDescr || ('misc_collaborator' | translate)}} }
        @case ('admin') { {{ 'Admin' }} }
    }
</ng-template>